import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { colors } from "./theme.js";
/**
 * 15-colour categorical palette (matches the admin app's Monogram palette) used
 * to give each credential/account a stable, unique colour so it's easy to tell
 * at a glance which account a session belongs to.
 */
export const CREDENTIAL_PALETTE = [
    "#1E3A5F", // navy
    "#E11D48", // rose
    "#8B5CF6", // purple
    "#0891B2", // cyan
    "#059669", // emerald
    "#F59E0B", // amber
    "#14B8A6", // teal
    "#6366F1", // indigo
    "#64748B", // slate
    "#D97706", // warm amber
    "#162D4A", // deep navy
    "#9333EA", // vivid purple
    "#0D9488", // dark teal
    "#DC2626", // red
    "#16A34A", // green
];
/** Deterministic palette colour for a credential key (FNV-1a hash). */
export function credentialColor(key) {
    let hash = 2166136261;
    for (let i = 0; i < key.length; i++) {
        hash ^= key.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
    }
    return CREDENTIAL_PALETTE[Math.abs(hash) % CREDENTIAL_PALETTE.length];
}
/**
 * A credential/account label with its deterministic colour — a tinted pill with
 * a colour dot. `colorKey` should be the STABLE identity (credential id) so the
 * colour stays consistent even if the label is edited; falls back to the label.
 */
export function CredentialChip({ label, colorKey, title, maxWidth = 180, style, }) {
    const color = credentialColor(colorKey || label);
    return (_jsxs("span", { title: title ?? label, style: {
            display: "inline-flex",
            alignItems: "center",
            gap: 5,
            padding: "2px 8px",
            borderRadius: 999,
            background: `${color}1A`, // ~10% tint
            border: `1px solid ${color}55`,
            color: colors.text,
            fontSize: "0.74rem",
            fontWeight: 600,
            maxWidth,
            ...style,
        }, children: [_jsx("span", { "aria-hidden": true, style: {
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: color,
                    flexShrink: 0,
                } }), _jsx("span", { style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: label })] }));
}
